import { useLocation } from 'react-router-dom';
import { TabsItem } from '@gv/triage-components';

export const usePageName = (tabs?: TabsItem[]): string | undefined => {
  const location = useLocation();
  const tab = tabs?.find(({ to }) => to.toString().includes(location.pathname));
  return tab?.label;
};
